module.exports = __webpack_public_path__ + "108422c43fc97e8de241a3442e8ed3dc.svg";